import type { AxiosResponse } from "axios";
import { api } from "../axiosInstance";
import { getBaseUrl } from "../api";

const ENDPOINTS = {
  create: `${getBaseUrl()}/general-ledger`,
  getAll: `${getBaseUrl()}/general-ledger`,
  deleteById: `${getBaseUrl()}/general-ledger`,
  updateById: `${getBaseUrl()}/general-ledger`,
};
 
export async function createGeneralLedger(payload: any): Promise<any> {
  const resp: AxiosResponse = await api.post(ENDPOINTS.create, payload);
  return resp.data;
}

// export async function getAllGeneralLedgers(): Promise<any[]> {
//   const resp = await api.get(ENDPOINTS.getAll);
//   return resp.data;
// }
export async function getAllGeneralLedgers(
  offset: number,
  limit: number,
  search?: string
) {
  const params: any = { offset, limit };

  if (search && search.trim() !== "") {
    params.search = search;
  }

  const resp = await api.get(ENDPOINTS.getAll, { params });
  return resp.data;
}


// export async function getGeneralLedgerNumbers(): Promise<string[]> {
//   const resp = await getAllGeneralLedgers(0, 1000);
//   return resp.items.map((item: any) => item.general_ledger);
// }
export async function getGeneralLedgerNumbers(): Promise<[string, string][]> {
  const resp = await getAllGeneralLedgers(0, 1000);

  return resp.items
    .filter((item: any) => item.status === true)
    .map((item: any) => [item.general_ledger, item.gl_role]);
}

export async function deleteGeneralLedgerById(glId: number): Promise<void> {
  await api.delete(`${ENDPOINTS.deleteById}/${glId}`);
}

export async function updateGeneralLedgerById(
  glId: number,
  payload: any
): Promise<any> {
  const resp = await api.put(`${ENDPOINTS.updateById}/${glId}`, payload);
  return resp.data;
}
